// Вкладка «Действующие» в «Созвонах» менеджера по преподавателям (Антон 22.10): преподы с 3+ проведёнными
// уроками — ОДНА очередь, плохие показатели наверху, фильтры. После созвона менеджер пишет итог (его видят
// звонильщики, сопроводители и переписчики) и может дать срок на исправление — появляется задача «проверить».
// Данные — GET /api/otbor/active. Макет: crm.ctg.school/preview/tutor-cabinet/calls-v10.html
import { useState, useEffect, useCallback, useMemo } from 'react'
import api from '../api'
import TeacherRating from './TeacherRating'

const GROUPS = [['', 'Все группы'], ['leader', 'Лидеры'], ['good', 'Хорошая конверсия'], ['other', 'Остальные']]
const WHY = [['stat', 'Просела статистика'], ['rating', 'Низкий рейтинг'], ['never', 'Созвона не было'], ['old', 'Давно не было созвона']]
const TERMS = [[3, 'Через 3 дня'], [7, 'Через неделю'], [14, 'Через 2 недели'], [30, 'Через месяц']]
const MONTHS = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря']

const fmtDate = (iso) => { if (!iso) return ''; const [, m, d] = iso.slice(0, 10).split('-'); return Number(d) + ' ' + (MONTHS[Number(m) - 1] || m) }
const firstNames = (full) => String(full || '').trim().split(/\s+/).slice(1).join(' ') || String(full || '').trim()
const inviteText = (name) => `Здравствуйте, ${firstNames(name)}! Хотим пообщаться с вами о работе на платформе. Выберите удобное время в личном кабинете: раздел «Созвон с куратором».`
const remindText = (name) => `Здравствуйте, ${firstNames(name)}! Напоминаем: мы приглашали вас на созвон с куратором. Выберите удобное время в личном кабинете.`
const REFUSE_REASONS = ['Нет времени', 'Не хочет созваниваться', 'Не отвечает', 'Другая причина']
const myId = () => { try { return JSON.parse(atob(localStorage.getItem('token').split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))).id } catch (e) { return null } }
const sentNote = (r) => { if (r && r.data && r.data.sent === false) alert('Тестовый режим: приглашение записано, но уведомление преподавателю НЕ отправлено (пока идёт проверка).') }
const plural = (n, a, b, c) => { const m = Math.abs(n) % 100, k = m % 10; return m > 10 && m < 20 ? c : k > 1 && k < 5 ? b : k === 1 ? a : c }

// Процент конверсии: зелёный >70, красный <30, жёлтый между (правило Антона 06.08, как на доске «Новые»)
function Conv({ value }) {
  // статистика не набралась — серый прочерк в углу, без подписей (Антон 22.10)
  const st = value == null
    ? { color: '#94A3B8', background: '#F8FAFC', border: '1px solid #E2E8F0' }
    : value > 70 ? { color: '#047857', background: '#ECFDF5', border: '1px solid #A7F3D0' }
    : value < 30 ? { color: '#B91C1C', background: '#FEF2F2', border: '1px solid #FECACA' }
    : { color: '#B45309', background: '#FFFBEB', border: '1px solid #FDE68A' }
  return <span className="shrink-0 text-[12px] font-extrabold rounded-lg px-1.5 py-0.5" style={st}>{value == null ? '—' : value + '%'}</span>
}

function ColHead({ color, title, n }) {
  return (
    <div className="flex items-center gap-1.5 mb-2">
      <span className="w-2 h-2 rounded-full shrink-0" style={{ background: color }} />
      <b className="text-[12.5px]">{title}</b>
      <span className="text-[11.5px] text-slate-400">{n}</span>
    </div>
  )
}

// Три цифры первых уроков за 30 дней: поставлено · дошло · остались
function Trio({ t }) {
  if (!t.trialsBooked) return <div className="text-[11px] text-slate-400">Первых уроков за 30 дней не было</div>
  return (
    <div className="grid grid-cols-3 gap-1.5 bg-slate-50 rounded-xl py-2">
      {[[t.trialsBooked, '#0F172A', 'поставлено'], [t.trialsDone, '#0369A1', 'дошло'], [t.trialsStayed, '#047857', 'остались']].map(([n, c, l]) => (
        <div key={l} className="text-center">
          <b className="block text-[17px] font-extrabold leading-tight" style={{ color: c }}>{n}</b>
          <small className="block text-[10px] text-slate-400 mt-0.5">{l}</small>
        </div>
      ))}
    </div>
  )
}

// Ответственный менеджер: строка + «Передать» / «Взять себе»
function OwnerLine({ t, me, onOwner, onTake }) {
  const mineNow = t.owner && t.owner.id === me
  return (
    <div className="flex items-center gap-2 text-[11.5px] text-slate-500">
      {t.owner
        ? <span>Ответственный: <b className="text-slate-700">{mineNow ? 'вы' : t.owner.name}</b></span>
        : <span className="font-semibold" style={{ color: '#B45309' }}>Без ответственного</span>}
      {t.owner
        ? <button className="ml-auto text-sky-700 font-bold" onClick={() => onOwner(t)}>Передать</button>
        : <button className="ml-auto text-sky-700 font-bold" onClick={() => onTake(t)}>Взять себе</button>}
    </div>
  )
}

function Card({ t, cls = '', children }) {
  return (
    <div className={'rounded-xl p-2.5 mb-2.5 bg-white flex flex-col gap-2 ' + (cls || 'border border-slate-200')}>
      <div className="flex items-start gap-2">
        <div className="flex-1 min-w-0 text-[13.5px] font-bold leading-tight">{t.name}</div>
        <Conv value={t.conversion} />
      </div>
      <div className="flex items-center flex-wrap gap-x-1.5 text-[12px] text-slate-500 -mt-1">
        <span>{(t.subjects || []).join(', ') || '—'}</span>
        <TeacherRating mkId={t.mkId} rating={t.rating} reviewCount={t.reviewCount} />
      </div>
      {children}
    </div>
  )
}

const btn = 'w-full rounded-lg border text-[12px] font-bold py-1.5'
const BTN_STYLE = {
  main: { borderColor: '#BAE6FD', background: '#F0F9FF', color: '#075985' },
  plain: { borderColor: '#E2E8F0', background: '#fff', color: '#475569' },
  green: { borderColor: '#A7F3D0', background: '#ECFDF5', color: '#047857' },
  amber: { borderColor: '#D97706', background: '#D97706', color: '#fff' },
  red: { borderColor: '#DC2626', background: '#DC2626', color: '#fff' },
}

function Shell({ title, sub, onClose, children, w = 460 }) {
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center p-4 pt-24" style={{ background: 'rgba(15,23,42,.45)' }}
      onClick={e => { if (e.target === e.currentTarget) onClose() }}>
      <div className="bg-white rounded-2xl max-w-full overflow-hidden" style={{ width: w }}>
        <div className="p-4 border-b border-slate-100">
          <b className="text-[14px]">{title}</b>
          {sub && <div className="text-[11.5px] text-slate-400 mt-1 leading-snug">{sub}</div>}
        </div>
        <div className="p-4">{children}</div>
      </div>
    </div>
  )
}

// «Позвать на созвон»: причина (видят коллеги, препод НЕ видит) + текст уведомления целиком до отправки
function InviteModal({ teacher, onClose, onDone }) {
  const [reason, setReason] = useState('')
  const [busy, setBusy] = useState(false)
  const send = async () => {
    setBusy(true)
    try { const r = await api.post('/api/otbor/active/invite', { teacher_mk_id: teacher.mkId, teacher_name: teacher.name, reason }); sentNote(r); onDone() }
    catch (e) { alert(e.response?.data?.error || e.message); setBusy(false) }
  }
  return (
    <Shell title={'Позвать на созвон — ' + teacher.name} sub="Преподаватель получит уведомление в личном кабинете и увидит окошки для записи." onClose={onClose}>
      <div className="text-[12px] font-bold text-slate-700 mb-1">Причина <span className="text-slate-400 font-medium">(видят коллеги, преподаватель не видит)</span></div>
      <textarea value={reason} onChange={e => setReason(e.target.value)} placeholder="Например: просела конверсия, хотим понять, что мешает"
        className="w-full h-16 border border-slate-200 rounded-xl px-2.5 py-2 text-[12.5px] outline-none focus:border-sky-300 resize-none" />
      <div className="text-[12px] font-bold text-slate-700 mt-3 mb-1">Что получит преподаватель</div>
      <div className="text-[12px] text-slate-600 bg-slate-50 border border-slate-100 rounded-lg px-2.5 py-2 leading-snug">
        <b>Приглашение на созвон</b><br />{inviteText(teacher.name)}
      </div>
      <button disabled={busy} onClick={send} className="mt-3 w-full rounded-xl text-white text-[12.5px] font-bold py-2.5 disabled:opacity-50" style={{ background: '#0284C7' }}>Отправить приглашение</button>
    </Shell>
  )
}

function RemindModal({ teacher, onClose, onDone }) {
  const [busy, setBusy] = useState(false)
  const send = async () => {
    setBusy(true)
    try { const r = await api.post('/api/otbor/active/remind', { invite_id: teacher.invite.id }); sentNote(r); onDone() }
    catch (e) { alert(e.response?.data?.error || e.message); setBusy(false) }
  }
  return (
    <Shell title={'Напомнить — ' + teacher.name} sub="Повторное уведомление. Напоминать можно не чаще раза в 3 дня." onClose={onClose}>
      <div className="text-[12px] font-bold text-slate-700 mb-1">Что получит преподаватель</div>
      <div className="text-[12px] text-slate-600 bg-slate-50 border border-slate-100 rounded-lg px-2.5 py-2 leading-snug">
        <b>Напоминание о созвоне</b><br />{remindText(teacher.name)}
      </div>
      <button disabled={busy} onClick={send} className="mt-3 w-full rounded-xl text-white text-[12.5px] font-bold py-2.5 disabled:opacity-50" style={{ background: '#0284C7' }}>Отправить напоминание</button>
    </Shell>
  )
}

// «Отказался»: причина + комментарий; преподаватель вернётся в «Позвать на созвон» с красной пометкой
function RefuseModal({ teacher, onClose, onDone }) {
  const [reason, setReason] = useState('')
  const [comment, setComment] = useState('')
  const [busy, setBusy] = useState(false)
  const save = async () => {
    if (!reason) { alert('Выберите причину отказа'); return }
    setBusy(true)
    try { await api.post('/api/otbor/active/refuse', { teacher_mk_id: teacher.mkId, teacher_name: teacher.name, reason, comment }); onDone() }
    catch (e) { alert(e.response?.data?.error || e.message); setBusy(false) }
  }
  return (
    <Shell title={'Отказался от созвона — ' + teacher.name} sub="Он вернётся в «Позвать на созвон» с красной пометкой; с созвона будет снят." onClose={onClose}>
      <div className="flex flex-col gap-1.5">
        {REFUSE_REASONS.map(r => (
          <label key={r} className="flex items-center gap-2 text-[12.5px] border rounded-lg px-2.5 py-2 cursor-pointer"
            style={reason === r ? { borderColor: '#7DD3FC', background: '#F0F9FF' } : { borderColor: '#E2E8F0' }}>
            <input type="radio" name="refuse" checked={reason === r} onChange={() => setReason(r)} />{r}
          </label>
        ))}
      </div>
      <textarea value={comment} onChange={e => setComment(e.target.value)} placeholder="Комментарий (необязательно)"
        className="mt-2 w-full h-14 border border-slate-200 rounded-xl px-2.5 py-2 text-[12.5px] outline-none focus:border-sky-300 resize-none" />
      <button disabled={busy} onClick={save} className="mt-3 w-full rounded-xl text-white text-[12.5px] font-bold py-2.5 disabled:opacity-50" style={{ background: '#B91C1C' }}>Записать отказ</button>
    </Shell>
  )
}

// «Передать»: список менеджеров с нагрузкой
function OwnerModal({ teacher, onClose, onDone }) {
  const [list, setList] = useState(null)
  useEffect(() => { api.get('/api/otbor/active/managers').then(r => setList(r.data.managers)).catch(() => setList([])) }, [])
  const give = async (id) => {
    try { await api.post('/api/otbor/active/owner', { teacher_mk_id: teacher.mkId, manager_id: id }); onDone() }
    catch (e) { alert(e.response?.data?.error || e.message) }
  }
  return (
    <Shell title={'Передать преподавателя — ' + teacher.name} sub={teacher.owner ? 'Сейчас отвечает: ' + teacher.owner.name : 'Сейчас ответственного нет'} onClose={onClose} w={420}>
      {!list && <div className="text-[12.5px] text-slate-400">Загрузка…</div>}
      {list && list.map(m => (
        <button key={m.id} onClick={() => give(m.id)} className="w-full flex items-center gap-2 border border-slate-200 rounded-xl px-3 py-2.5 mb-1.5 text-[13px] hover:border-sky-300 hover:bg-sky-50">
          <b>{m.name}</b>
          <span className="ml-auto text-[11px] text-slate-400">{m.load} {plural(m.load, 'преподаватель', 'преподавателя', 'преподавателей')} · {m.onShift ? 'на смене' : 'не на смене'}</span>
        </button>
      ))}
      {list && list.length === 0 && <div className="text-[12.5px] text-slate-400">Менеджеров нет</div>}
    </Shell>
  )
}

// Окно «Итог созвона» с действующим: заметка + необязательный срок
function ResultModal({ teacher, slotId, onClose, onSaved, onRefuse }) {
  const [note, setNote] = useState('')
  const [term, setTerm] = useState(0)        // 0 = без срока
  const [saving, setSaving] = useState(false)
  const due = term ? (() => { const d = new Date(Date.now() + term * 864e5); return d.toISOString().slice(0, 10) })() : null
  const noshow = async () => {
    if (!window.confirm('Не пришёл на созвон? Он будет снят со слота и вернётся в очередь.')) return
    setSaving(true)
    try { await api.post('/api/otbor/active/refuse', { teacher_mk_id: teacher.mkId, teacher_name: teacher.name, kind: 'noshow', reason: 'Не пришёл на созвон' }); onSaved() }
    catch (e) { alert(e.response?.data?.error || e.message); setSaving(false) }
  }
  const save = async () => {
    if (!note.trim()) { alert('Сначала запишите итог созвона'); return }
    setSaving(true)
    try {
      await api.post('/api/otbor/active/result', {
        teacher_mk_id: teacher.mkId, teacher_name: teacher.name, slot_id: slotId || null, note, term_days: term || 0,
        snapshot: { conversion: teacher.conversion, booked: teacher.trialsBooked, stayed: teacher.trialsStayed, rating: teacher.rating },
      })
      onSaved()
    } catch (e) { alert(e.response?.data?.error || e.message); setSaving(false) }
  }
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center p-4 pt-24" style={{ background: 'rgba(15,23,42,.45)' }}
      onClick={e => { if (e.target === e.currentTarget) onClose() }}>
      <div className="bg-white rounded-2xl w-[460px] max-w-full overflow-hidden">
        <div className="p-4 border-b border-slate-100">
          <b className="text-[14px]">Итог созвона — {teacher.name}</b>
          <div className="text-[11.5px] text-slate-400 mt-1 leading-snug">
            Запишите, что обсудили и о чём договорились. Это увидят звонильщики, сопроводители и переписчики.
          </div>
        </div>
        <div className="p-4">
          <textarea value={note} onChange={e => setNote(e.target.value)} autoFocus
            placeholder="Например: берёт новых учеников на вечер, просит больше старшеклассников"
            className="w-full h-24 border border-slate-200 rounded-xl px-2.5 py-2 text-[12.5px] outline-none focus:border-sky-300 resize-none" />
          <div className="mt-3 border border-slate-200 rounded-xl p-3">
            <div className="text-[12.5px] font-bold text-slate-700">Дали срок на исправление <span className="text-slate-400 font-medium">(необязательно)</span></div>
            <div className="flex flex-wrap gap-1.5 mt-2">
              {TERMS.map(([d, label]) => (
                <button key={d} type="button" onClick={() => setTerm(term === d ? 0 : d)}
                  className="rounded-full border text-[12px] font-semibold px-2.5 py-1"
                  style={term === d ? { background: '#0284C7', borderColor: '#0284C7', color: '#fff' } : { background: '#fff', borderColor: '#E2E8F0', color: '#475569' }}>
                  {label}
                </button>
              ))}
            </div>
            {due && (
              <div className="text-[11.5px] text-slate-500 mt-2 leading-snug">
                Будет задача «Проверить преподавателя» на <b>{fmtDate(due)}</b>. Она появится на карточке и в полосе «Контроль после созвона».
              </div>
            )}
          </div>
          <button disabled={saving} onClick={save} className="mt-3 w-full rounded-xl text-white text-[12.5px] font-bold py-2.5 disabled:opacity-50" style={{ background: '#047857' }}>
            Сохранить итог
          </button>
          <div className="mt-2 grid grid-cols-2 gap-2">
            <button disabled={saving} onClick={noshow} className="rounded-xl border border-slate-200 bg-white text-slate-600 text-[12.5px] font-bold py-2.5">Не пришёл на созвон</button>
            <button disabled={saving} onClick={() => onRefuse(teacher)} className="rounded-xl border border-slate-200 bg-white text-slate-600 text-[12.5px] font-bold py-2.5">Отказался</button>
          </div>
          <div className="text-[10.5px] text-slate-400 mt-2 leading-snug">«Сохранить итог» — преподаватель переедет в «Созвон проведён». «Не пришёл» — вернётся в очередь. «Отказался» — вернётся в очередь с пометкой об отказе.</div>
        </div>
      </div>
    </div>
  )
}

// Окно «Проверка после срока»: было на созвоне → стало сейчас, три решения
function CheckModal({ teacher, onClose, onDone }) {
  const [busy, setBusy] = useState(false)
  const [extend, setExtend] = useState(false)
  const c = teacher.control, snap = c.snapshot || {}
  const close = async (result, days) => {
    setBusy(true)
    try { await api.post('/api/otbor/followups/' + c.id + '/close', { result, days }); onDone(result) }
    catch (e) { alert(e.response?.data?.error || e.message); setBusy(false) }
  }
  const pct = (v) => v == null ? '—' : v + '%'
  const arrow = (was, now) => was == null || now == null ? '' : now > was ? ' ↑' : now < was ? ' ↓' : ''
  const color = (was, now, goodUp = true) => was == null || now == null || now === was ? '#0F172A' : (now > was) === goodUp ? '#047857' : '#B91C1C'
  const rows = [
    ['Конверсия', pct(snap.conversion), pct(teacher.conversion), snap.conversion, teacher.conversion, true],
    ['Первых уроков за 30 дней', snap.booked ?? '—', teacher.trialsBooked, null, null, true],
    ['Остались после первого', snap.stayed ?? '—', teacher.trialsStayed, snap.stayed, teacher.trialsStayed, true],
    ['Рейтинг', snap.rating ?? '—', teacher.rating ?? '—', snap.rating, teacher.rating, true],
  ]
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center p-4 pt-16" style={{ background: 'rgba(15,23,42,.45)' }}
      onClick={e => { if (e.target === e.currentTarget) onClose() }}>
      <div className="bg-white rounded-2xl w-[500px] max-w-full overflow-hidden">
        <div className="p-4 border-b border-slate-100">
          <b className="text-[14px]">Проверка после срока — {teacher.name}</b>
          <div className="text-[11.5px] text-slate-400 mt-1">Срок до {fmtDate(c.dueDate)}</div>
        </div>
        <div className="p-4">
          {c.note && <div className="text-[12px] text-slate-600 bg-slate-50 border border-slate-100 rounded-lg px-2.5 py-2 mb-3"><b>Договорились:</b> {c.note}</div>}
          <table className="w-full text-[12.5px]">
            <thead><tr className="text-[11px] text-slate-400 text-left"><th className="py-1 font-bold"></th><th className="py-1 font-bold">На созвоне</th><th className="py-1 font-bold">Сейчас</th></tr></thead>
            <tbody>
              {rows.map(([label, was, now, wn, nn, up]) => (
                <tr key={label} className="border-t border-slate-100">
                  <td className="py-1.5">{label}</td>
                  <td className="py-1.5">{was}</td>
                  <td className="py-1.5 font-bold" style={{ color: color(wn, nn, up) }}>{now}{arrow(wn, nn)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {!extend ? (
            <>
              <button disabled={busy} onClick={() => close('ok')} className="mt-4 w-full rounded-xl text-white text-[12.5px] font-bold py-2.5 disabled:opacity-50" style={{ background: '#047857' }}>
                Всё хорошо, снять контроль
              </button>
              <div className="mt-2 grid grid-cols-2 gap-2">
                <button disabled={busy} onClick={() => setExtend(true)} className="rounded-xl border border-slate-200 bg-white text-slate-600 text-[12.5px] font-bold py-2.5">Дать ещё срок</button>
                <button disabled={busy} onClick={() => close('recall')} className="rounded-xl border border-slate-200 bg-white text-slate-600 text-[12.5px] font-bold py-2.5">Позвать на созвон снова</button>
              </div>
            </>
          ) : (
            <div className="mt-4">
              <div className="text-[12px] text-slate-500 mb-2">На сколько продлеваем?</div>
              <div className="flex flex-wrap gap-1.5">
                {TERMS.map(([d, label]) => (
                  <button key={d} disabled={busy} onClick={() => close('extend', d)} className="rounded-full border border-slate-200 bg-white text-slate-600 text-[12px] font-semibold px-3 py-1.5">{label}</button>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

// Выбор слота для «Назначить созвон»
function PickSlot({ teacher, slots, busy, onPick, onClose }) {
  const free = slots.filter(s => s.members.length < s.capacity)
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center p-4 pt-24" style={{ background: 'rgba(15,23,42,.45)' }}
      onClick={e => { if (e.target === e.currentTarget) onClose() }}>
      <div className="bg-white rounded-2xl w-[420px] max-w-full overflow-hidden">
        <div className="p-4 border-b border-slate-100">
          <b className="text-[14px]">Созвон для: {teacher.name}</b>
          <div className="text-[12px] text-slate-400 mt-0.5">Выберите свободное окошко</div>
        </div>
        <div className="p-3 max-h-[50vh] overflow-y-auto">
          {free.map(s => (
            <button key={s.id} disabled={busy} onClick={() => onPick(s)}
              className="w-full flex items-center gap-2 border border-slate-200 rounded-xl px-3 py-2.5 mb-1.5 text-[13px] hover:border-sky-300 hover:bg-sky-50">
              <b>{fmtDate(s.slot_date)} · {s.slot_time}</b>
              <span className="ml-auto text-[11px] text-slate-400">свободно {s.capacity - s.members.length}</span>
            </button>
          ))}
          {free.length === 0 && <div className="text-[12.5px] text-slate-400 text-center py-4">Свободных окошек нет — добавьте слот во вкладке «Новые» кнопкой «Слоты созвонов»</div>}
        </div>
      </div>
    </div>
  )
}

export default function OtborActive({ onCounts }) {
  const [data, setData] = useState(null)
  const [err, setErr] = useState(null)
  const [busy, setBusy] = useState(false)
  const [q, setQ] = useState('')
  const [group, setGroup] = useState('')
  const [why, setWhy] = useState([])
  const [subject, setSubject] = useState('')
  const [onlyCtl, setOnlyCtl] = useState(false)
  const [pickFor, setPickFor] = useState(null)
  const [result, setResult] = useState(null)   // {teacher, slotId}
  const [check, setCheck] = useState(null)
  const [inviteFor, setInviteFor] = useState(null)
  const [remindFor, setRemindFor] = useState(null)
  const [refuseFor, setRefuseFor] = useState(null)
  const [ownerFor, setOwnerFor] = useState(null)
  const [mine, setMine] = useState(false)      // «Мои / Все»: по умолчанию все
  const me = myId()

  const load = useCallback(() => {
    api.get('/api/otbor/active')
      .then(r => { setData(r.data); setErr(null); if (onCounts) onCounts(r.data.counts.candidates + r.data.counts.invited + r.data.counts.held + r.data.counts.scheduled) })
      .catch(e => setErr(e.response?.data?.error || e.message))
  }, [onCounts])
  useEffect(() => { load() }, [load])

  const subjects = useMemo(() => {
    if (!data) return []
    const s = new Set()
    data.candidates.concat(data.held).forEach(t => (t.subjects || []).forEach(x => s.add(x)))
    return [...s].sort((a, b) => a.localeCompare(b, 'ru'))
  }, [data])

  if (err) return (
    <div className="p-8 text-center text-[13px] text-slate-500">
      Список не загрузился: {err}
      <div><button className="mt-3 text-sky-700 font-semibold" onClick={load}>Попробовать ещё раз</button></div>
    </div>
  )
  if (!data) return <div className="p-8 text-center text-[13px] text-slate-400">Загрузка списка…</div>

  const ql = q.trim().toLowerCase()
  const pass = (t) => {
    if (ql && !t.name.toLowerCase().includes(ql)) return false
    if (group && t.group !== group) return false
    if (why.length && !why.some(w => t.reasons.some(r => r.code === w))) return false
    if (subject && !(t.subjects || []).includes(subject)) return false
    if (mine && !(t.owner && t.owner.id === me)) return false
    return true
  }
  const cands = onlyCtl ? [] : data.candidates.filter(pass)
  const invited = onlyCtl ? [] : data.invited.filter(pass)
  const held = data.held.filter(t => pass(t) && (!onlyCtl || t.control))
  const slotsShown = data.slotsActive

  const act = async (fn) => {
    setBusy(true)
    try { await fn(); load() } catch (e) { alert(e.response?.data?.error || e.message) } finally { setBusy(false) }
  }
  const take = (t) => act(() => api.post('/api/otbor/active/owner', { teacher_mk_id: t.mkId }))
  const assign = (slot, t) => { setPickFor(null); act(() => api.post('/api/otbor/slots/' + slot.id + '/members', { teacher_mk_id: t.mkId, teacher_name: t.name })) }
  const removeMember = (slotId, memberId) => act(() => api.delete('/api/otbor/slots/' + slotId + '/members/' + memberId))

  const s = data.strip
  const hasStrip = s.overdue + s.today + s.wait > 0
  const toggleWhy = (code) => setWhy(why.includes(code) ? why.filter(x => x !== code) : [...why, code])
  const resetAll = () => { setQ(''); setGroup(''); setWhy([]); setSubject('') }
  const filtered = ql || group || why.length || subject

  return (
    <div>
      {/* фильтры */}
      <div className="flex flex-wrap items-center gap-2 mb-2">
        <input value={q} onChange={e => setQ(e.target.value)} placeholder="Поиск по имени"
          className="border border-slate-200 bg-white rounded-xl px-3 py-2 text-[12.5px] w-[220px] outline-none focus:border-sky-300" />
        <select value={group} onChange={e => setGroup(e.target.value)} className="border border-slate-200 bg-white rounded-xl px-2.5 py-2 text-[12.5px] font-semibold text-slate-600">
          {GROUPS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </select>
        <select value={subject} onChange={e => setSubject(e.target.value)} className="border border-slate-200 bg-white rounded-xl px-2.5 py-2 text-[12.5px] font-semibold text-slate-600">
          <option value="">Все предметы</option>
          {subjects.map(x => <option key={x} value={x}>{x}</option>)}
        </select>
        {WHY.map(([code, label]) => (
          <button key={code} onClick={() => toggleWhy(code)} className="rounded-full border text-[12px] font-semibold px-2.5 py-1.5"
            style={why.includes(code) ? { background: '#0284C7', borderColor: '#0284C7', color: '#fff' } : { background: '#fff', borderColor: '#E2E8F0', color: '#475569' }}>
            {label}
          </button>
        ))}
        <div className="ml-auto inline-flex rounded-xl border border-slate-200 bg-white overflow-hidden">
          {[[true, 'Мои'], [false, 'Все']].map(([v, l]) => (
            <button key={l} onClick={() => setMine(v)} className="px-3.5 py-2 text-[12.5px] font-bold"
              style={mine === v ? { background: '#0369A1', color: '#fff' } : { color: '#475569' }}>{l}</button>
          ))}
        </div>
        {filtered && <button onClick={resetAll} className="text-[12px] text-sky-700 font-bold px-1">Сбросить всё</button>}
      </div>

      {/* контроль после созвона */}
      {hasStrip && (
        <div className="flex items-center flex-wrap gap-4 bg-white border border-slate-200 rounded-2xl px-3.5 py-2 mb-3 text-[12.5px]">
          <b>Контроль после созвона</b>
          {s.overdue > 0 && <span className="flex items-center gap-1.5 font-bold" style={{ color: '#B91C1C' }}><i className="w-2 h-2 rounded-full" style={{ background: '#DC2626' }} />Просрочено: {s.overdue}</span>}
          {s.today > 0 && <span className="flex items-center gap-1.5 font-bold" style={{ color: '#B45309' }}><i className="w-2 h-2 rounded-full" style={{ background: '#F59E0B' }} />Срок пришёл сегодня: {s.today}</span>}
          {s.wait > 0 && <span className="flex items-center gap-1.5 font-bold text-slate-600"><i className="w-2 h-2 rounded-full bg-slate-400" />Ждём срок: {s.wait}</span>}
          <button onClick={() => setOnlyCtl(!onlyCtl)} className="ml-auto rounded-lg border border-sky-200 bg-sky-50 text-sky-800 text-[12px] font-bold px-2.5 py-1">
            {onlyCtl ? 'Показать всех' : 'Показать только их'}
          </button>
        </div>
      )}

      <div className="flex gap-3 items-start overflow-x-auto">
        {/* Позвать на созвон */}
        <div className="flex-none w-[250px] bg-white border border-slate-200 rounded-2xl p-2.5">
          <ColHead color="#B45309" title="Позвать на созвон" n={cands.length} />
          {cands.map(t => (
            <Card key={t.mkId} t={t}>
              {t.reasons.length > 0 && (
                <div className="flex flex-wrap gap-1">
                  {t.reasons.map(r => (
                    <span key={r.code} className="text-[11px] font-bold rounded-md px-1.5 py-0.5 leading-tight"
                      style={r.code === 'never' || r.code === 'old' ? { color: '#475569', background: '#F1F5F9', border: '1px solid #E2E8F0' } : { color: '#B91C1C', background: '#FEF2F2', border: '1px solid #FECACA' }}>
                      {r.text}
                    </span>
                  ))}
                </div>
              )}
              <Trio t={t} />
              <div className="text-[11.5px] text-slate-500">Занимаются сейчас — {t.regularStudents}</div>
              {t.refused && (
                <div className="text-[11.5px] font-bold rounded-lg px-2 py-1.5 leading-snug" style={{ color: '#B91C1C', background: '#FEF2F2', border: '1px solid #FECACA' }}>
                  {t.refused.kind === 'noshow' ? 'Не пришёл на созвон' : 'Отказался'} — {fmtDate(t.refused.at)}{t.refused.reason && t.refused.kind !== 'noshow' ? ', ' + t.refused.reason.toLowerCase() : ''}
                </div>
              )}
              <div className="text-[11.5px] text-slate-500 pt-2 border-t border-dashed border-slate-200">
                {t.lastCallAt ? 'Последний созвон — ' + fmtDate(t.lastCallAt) : 'Созвона не было'}
              </div>
              <OwnerLine t={t} me={me} onOwner={setOwnerFor} onTake={take} />
              <button disabled={busy} onClick={() => setInviteFor(t)} className={btn} style={BTN_STYLE.main}>Позвать на созвон</button>
              <button disabled={busy} onClick={() => setPickFor(t)} className={btn} style={BTN_STYLE.plain}>Назначить созвон</button>
            </Card>
          ))}
          {cands.length === 0 && <div className="text-[11.5px] text-slate-300 leading-relaxed">{onlyCtl ? 'Показаны только задачи с контролем' : filtered ? 'По этим фильтрам никого нет' : 'Очередь пуста'}</div>}
        </div>

        {/* Позвали — ждём ответа */}
        <div className="flex-none w-[250px] bg-white border border-slate-200 rounded-2xl p-2.5">
          <ColHead color="#B45309" title="Позвали — ждём ответа" n={invited.length} />
          {invited.map(t => (
            <Card key={t.mkId} t={t}>
              <Trio t={t} />
              <div className="text-[11.5px] text-slate-500">Занимаются сейчас — {t.regularStudents}</div>
              <div className="text-[11.5px] font-semibold leading-snug" style={{ color: '#B45309' }}>
                Позвали {fmtDate(t.invite.invitedAt)} · {t.invite.sent ? 'уведомление ушло' : 'тест: уведомление не отправляли'} · ответа нет
                {t.invite.remindCount > 0 && <> · напоминали {t.invite.remindCount} {plural(t.invite.remindCount, 'раз', 'раза', 'раз')}</>}
              </div>
              {t.invite.reason && <div className="text-[11.5px] text-slate-500 bg-slate-50 border border-slate-100 rounded-lg px-2 py-1.5 leading-snug">Причина: {t.invite.reason}</div>}
              <OwnerLine t={t} me={me} onOwner={setOwnerFor} onTake={take} />
              {t.invite.canRemind
                ? <button disabled={busy} onClick={() => setRemindFor(t)} className={btn} style={BTN_STYLE.main}>Напомнить</button>
                : <button disabled className={btn} style={{ ...BTN_STYLE.plain, color: '#94A3B8', background: '#F8FAFC' }}>Напомнить можно с {fmtDate(t.invite.remindFrom)}</button>}
              <button disabled={busy} onClick={() => setPickFor(t)} className={btn} style={BTN_STYLE.plain}>Назначить созвон</button>
              <button disabled={busy} onClick={() => setRefuseFor(t)} className={btn} style={{ ...BTN_STYLE.plain, color: '#94A3B8', fontWeight: 600 }}>Отказался</button>
            </Card>
          ))}
          {invited.length === 0 && <div className="text-[11.5px] text-slate-300 leading-relaxed">Пока никого — сюда попадают позванные кнопкой «Позвать на созвон»</div>}
        </div>

        {/* Созвон назначен */}
        <div className="flex-none w-[250px] bg-white border border-slate-200 rounded-2xl p-2.5">
          <ColHead color="#38BDF8" title="Созвон назначен" n={slotsShown.reduce((n, x) => n + x.members.length, 0)} />
          {slotsShown.map(sl => (
            <div key={sl.id} className="border-2 border-sky-300 bg-sky-50 rounded-xl p-2 mb-2.5">
              <div className="flex items-center gap-2 mb-1.5">
                <b className="text-[13px]">{fmtDate(sl.slot_date)} · {sl.slot_time}</b>
                <span className="ml-auto text-[11px] font-bold rounded-full px-2" style={{ color: '#B45309', background: '#FFFBEB', border: '1px solid #FDE68A' }}>{sl.members.length} из {sl.capacity}</span>
              </div>
              {sl.members.map(m => {
                const t = m
                return (
                  <Card key={m.memberId} t={t} cls="border border-sky-200">
                    <Trio t={t} />
                    <button disabled={busy} onClick={() => setResult({ teacher: t, slotId: sl.id })} className={btn} style={BTN_STYLE.green}>Итог созвона</button>
                    <button disabled={busy} onClick={() => removeMember(sl.id, m.memberId)} className={btn} style={{ ...BTN_STYLE.plain, color: '#94A3B8', fontWeight: 600 }}>Убрать из слота</button>
                  </Card>
                )
              })}
            </div>
          ))}
          {slotsShown.length === 0 && <div className="text-[11.5px] text-slate-300 leading-relaxed">Пока никого. Окошки создаются во вкладке «Новые» кнопкой «Слоты созвонов»</div>}
        </div>

        {/* Созвон проведён */}
        <div className="flex-none w-[250px] bg-white border border-slate-200 rounded-2xl p-2.5">
          <ColHead color="#047857" title="Созвон проведён" n={held.length} />
          {held.map(t => {
            const c = t.control
            const cls = c && c.state === 'overdue' ? 'border-[1.5px] border-red-300' : c && c.state === 'today' ? 'border-[1.5px] border-amber-300' : 'border border-slate-200'
            const bg = c && c.state === 'overdue' ? '#FFF8F8' : c && c.state === 'today' ? '#FFFCF2' : '#fff'
            return (
              <div key={t.mkId} style={{ background: bg }} className="rounded-xl">
                <Card t={t} cls={cls}>
                  {t.note && <div className="text-[12px] text-slate-600 bg-slate-50 border border-slate-100 rounded-lg px-2 py-1.5 leading-snug">{t.note}</div>}
                  {c && c.state === 'overdue' && (
                    <div className="rounded-lg px-2.5 py-2 text-[12px]" style={{ background: '#FEF2F2', border: '1px solid #FECACA', color: '#B91C1C' }}>
                      <b>Срок вышел {-c.days} {plural(-c.days, 'день', 'дня', 'дней')} назад</b>
                      <div className="text-[11.5px] text-slate-500">Срок был до {fmtDate(c.dueDate)}</div>
                    </div>
                  )}
                  {c && c.state === 'today' && (
                    <div className="rounded-lg px-2.5 py-2 text-[12px]" style={{ background: '#FFFBEB', border: '1px solid #FDE68A', color: '#B45309' }}>
                      <b>Срок пришёл — сегодня</b>
                      <div className="text-[11.5px] text-slate-500">Срок до {fmtDate(c.dueDate)}</div>
                    </div>
                  )}
                  {c && c.state === 'wait' && (
                    <div className="rounded-lg px-2.5 py-2 text-[12px] font-semibold text-slate-600 bg-slate-50 border border-slate-100">
                      Контроль {fmtDate(c.dueDate)} · через {c.days} {plural(c.days, 'день', 'дня', 'дней')}
                    </div>
                  )}
                  <Trio t={t} />
                  <div className="text-[11.5px] text-slate-500">Занимаются сейчас — {t.regularStudents}</div>
                  {t.heldAt && <div className="text-[11.5px] text-slate-500">Созвон — {fmtDate(t.heldAt)}{t.reviewer ? ' · ' + t.reviewer : ''}</div>}
                  <OwnerLine t={t} me={me} onOwner={setOwnerFor} onTake={take} />
                  {c && (c.state === 'overdue' || c.state === 'today') && (
                    <button disabled={busy} onClick={() => setCheck(t)} className={btn} style={c.state === 'overdue' ? BTN_STYLE.red : BTN_STYLE.amber}>Проверить</button>
                  )}
                  {c && c.state === 'wait' && (
                    <button disabled={busy} onClick={() => setCheck(t)} className={btn} style={BTN_STYLE.plain}>Проверить раньше срока</button>
                  )}
                </Card>
              </div>
            )
          })}
          {held.length === 0 && <div className="text-[11.5px] text-slate-300 leading-relaxed">Пока никого</div>}
        </div>
      </div>

      {pickFor && <PickSlot teacher={pickFor} slots={data.slots} busy={busy} onPick={(sl) => assign(sl, pickFor)} onClose={() => setPickFor(null)} />}
      {result && <ResultModal teacher={result.teacher} slotId={result.slotId} onClose={() => setResult(null)} onSaved={() => { setResult(null); load() }}
        onRefuse={(tt) => { setResult(null); setRefuseFor(tt) }} />}
      {inviteFor && <InviteModal teacher={inviteFor} onClose={() => setInviteFor(null)} onDone={() => { setInviteFor(null); load() }} />}
      {remindFor && <RemindModal teacher={remindFor} onClose={() => setRemindFor(null)} onDone={() => { setRemindFor(null); load() }} />}
      {refuseFor && <RefuseModal teacher={refuseFor} onClose={() => setRefuseFor(null)} onDone={() => { setRefuseFor(null); load() }} />}
      {ownerFor && <OwnerModal teacher={ownerFor} onClose={() => setOwnerFor(null)} onDone={() => { setOwnerFor(null); load() }} />}
      {check && <CheckModal teacher={check} onClose={() => setCheck(null)} onDone={() => { setCheck(null); load() }} />}
    </div>
  )
}
